<template>
  <div class="staff-record">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <!-- Change lg to 9 if another component is placed on the right  -->
        <div v-if="currentUser.privileges.canAddStaff" class="text-right mx-4 my-2">
          <!-- import excel trigger btn -->
          <v-btn color="white" 
            @click="showDialog = true"
            class="mr-3"
            rounded
            light
          >
            Import
            <v-icon right>
              mdi-import
            </v-icon>
          </v-btn>
          <v-btn rounded color="primary" to="/staff/add" id="add-staff-btn">
            <!-- <v-icon>mdi-account-plus</v-icon> -->
            Add Staff
          </v-btn>
          <!-- <v-btn rounded color="primary" to="/staff/daily-reports" id="dailyReports-staff-btn">
            Daily Reports
          </v-btn> -->          
          <v-btn
            color="primary"
            rounded
            class="ml-3"
            :to="{name:'ManageDepartments'}"
          > 
            Manage Departments
          </v-btn>
        
        </div>
        <v-card class="mx-4 my-4">
          <v-card-title>
            Staff Record
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            
          </v-card-title>
          <v-row class="mx-4">
            
            <v-spacer></v-spacer>
            <v-col cols="12" md="4"  class="text-right">
              <download-excel
                v-if="currentUser.privileges.canExportStaff"
                :fetch="getExportData"
                :fields="export_fields"
                :name="getExportName"
              >
                <v-btn
                  class="ma-2"
                  :loading="export_in_progress"
                  :disabled="export_in_progress"
                  color="white"
                  elevation="1"

                >
                  Export
                  <v-icon right dark> mdi-export </v-icon>
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </download-excel>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="staff"
            :search="search"
            :options.sync="options"
            :items-per-page="15"
            :multi-sort="true"
            :server-items-length="pagination.totalCount"
            @click:row="clickStaffRow"
            class="row-pointer"
            id="staff-data-table"
          >
            <template v-slot:item.employee_id="{ item }">
              <h5 :class="item.disabled ? 'red--text': ''">{{ item.employee_id }}</h5>
            </template>
            <template v-slot:item.image="{ item }">
              <v-avatar width="30" height="30" class="mb-2">
                <img :src="item.image" />
              </v-avatar>
            </template>
            <template v-slot:item.full_name="{ item }">
              <h5 :class="item.disabled ? 'red--text': ''" id="staff-full-name">{{ item.full_name }}
              <v-tooltip bottom v-if="item.disabled">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="red"
                    class="mx-2"
                    small
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>This staff is disabled.</span>
              </v-tooltip>
              </h5>
            </template>
            <template v-slot:item.phone="{ item }">
              <h5 :class="item.disabled ? 'red--text': ''">{{ item.phone }}</h5>
            </template>
            <template v-slot:item.roles="{ item }">
              <v-chip :color="item.disabled ? 'red': 'primary'"  v-if="item.is_admin" outlined>
                <h5>Admin</h5>
              </v-chip>
              <v-chip  :color="item.disabled ? 'red': 'primary'"  v-if="item.is_faculty" outlined>
                <h5>Faculty</h5>
              </v-chip>
            </template>
            <template v-slot:item.designation="{ item }">
              <h5 :class="item.disabled ? 'red--text': ''" class="text-center">{{ item.designation? item.designation : "-" }}</h5>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- import excel dialog -->
    <ImportExcelDialog
			:showDialog="showDialog"
			title="Import Staff"
			@closeImportDialog="closeImportDialog"
			:endpoint="endpoints.importExcelStaff"
			:staticFile="endpoints.static.staffImportFile"
		/>

    <!-- snackbar -->
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color" multi-line>
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
				<v-btn dark text v-bind="attrs" @click="snackbar.visible = false">
					Close
				</v-btn>
			</template>
		</v-snackbar>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import Helper from "@utils/misc";
import JsonExcel from "vue-json-excel";
import ImportExcelDialog from "@components/widgets/dialogs/ImportExcelDialog.vue";
import TourHelper from "@utils/tour_helper";


export default {
  name: "StaffRecord",
  props: {
    searchPhoneNumber : {
      type: String,
      default: "",
    },
  },
  components: {
    downloadExcel: JsonExcel,
    ImportExcelDialog
  },
  data() {
    return {
      search: "",
      options: {},
      pagination: {
        totalCount: 0,
        url: endpoints.getAllStaff,
      },
      headers: [
        {
          text: "Employee ID",
          align: "start",
          sortable: false,
          value: "employee_id",
        },
        { text: "Photo", value: "image", sortable: false },
        { text: "Name", value: "full_name" },
        { text: "Phone Number", value: "phone" },
        { text: "Designation", value: "designation" },
        { text: "Roles", value: "roles" },
      ],
      staff: [],
      snackbar: {
        visible: false,
        text: "",
      },
      export_url : endpoints.getAllStaff + "?extract=true",
      export_in_progress: false,
      export_fields: {
        "Employee ID": "employee_id",
        "Full Name": "full_name",
        "Phone" : "phone",
        "Username":"username",
      },

      // for import excel
			showDialog: false,
			endpoints: endpoints,
    };
  },
  computed: {
    ...mapGetters(["accessToken", "currentUser"]),
    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
     getExportName() {
      return Helper.getExportName();
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
      var steps = [];
      steps.push({id: '1', title: "Welcome to Staff Section!", description: "Let's start with a quick tour!", videoLink: "https://youtube.com"});
      steps.push({id: '2', title: "Add Staff", description: "New Staff entry can be added from here", el: '#add-staff-btn',position:'left'});      
      steps.push({id: '3', title: "Staff Table", description: "All Staff related Information are accessible here, click on name for individual Staff Information", el: '#staff-data-table',position:'top'});
      // steps.push({id: '4', description: "", el: '#staff-full-name',position:'top'});

      TourHelper.startTour(this, "staff", steps);
    },

    // receive dialog status from the component
		closeImportDialog(showDialog) {
			this.showDialog = showDialog
		},

    // get all staff from the server
    async getAllStaff() {
      var response;
      var url = this.pagination.url;
      // if search query exists, add to the url as a GET param w/o disturbing other params
      if (this.search) {
        url += (url.split("?")[1] ? "&" : "?") + "query=" + this.search;
      }

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: url,
        responseVar: response,
      });

      if (response) {
        this.staff = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      }
    },

    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },


    async getExportData(){
      this.export_in_progress = true;
      var response;

      if (this.search) {
        this.export_url += "&query=" + this.search;
      }

      response = await api.handleApi({
        apiEssentials: this.apiEssentials,
        url: this.export_url,
        responseVar: response,
      });

      if(response){
        this.export_in_progress = false;
        return response
      }
    },


    // handle row click
    clickStaffRow(value) {
      this.$router.push({ name: "StaffDetails", params: { id: value.id } });
    },
  },
  watch: {
    options: {
      async handler() {
        this.pagination.url =
          endpoints.getAllStaff + "?page=" + this.options.page;
        if (this.options.sortBy.length > 0) {
          // get url var
          var params = "&o=";
          // iterate over sortBy options and add sortby and sortdesc seperated with commas
          for (var sortOption in this.options.sortBy) {
            params +=
              (this.options.sortDesc[sortOption] ? "" : "-") +
              this.options.sortBy[sortOption];
            if (sortOption != this.options.sortBy.length - 1) params += ",";
          }
          this.pagination.url += params;
        }
        this.getAllStaff();
      },
    },
    search: {
      async handler() {
        this.options.page = 1;
        var searched = this.search;
        var self = this;
        setTimeout(function () {
          if (searched == self.search) {
            self.getAllStaff();
          }
        }, 500);
      },
    },
  },
  created() {
      this.handleTour();
      // this.getAllStaff();
      if (this.searchPhoneNumber) {
        this.search = this.searchPhoneNumber;
      }
    },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>